/**
 * exporter.ts
 * Copyright (c) 2017, My Coverage Plan, Inc.
 * All rights reserved.
 */

import { assignOnly } from "../support/utilities/functions";

export interface ExportFormatDescriptor
{
  formatName : string;
  displayName : string;
  description : string;
  mimeType : string;
  allowsInlining : boolean;
  collectionDelimiter : string | null;
  customizableCollectionDelimiter : boolean;
  useRecordRepetition : boolean;
  fileExtension : string;
}

export class Exporter implements ExportFormatDescriptor
{
    constructor (
        public name : string,
        public displayName : string,
        public description : string
    )
    {
        // (Exporter is mostly a "dumb" class at the moment)
    }

    public childCounter : number = 0;

    public mimeType : string = "text/plain";
    public allowsInlining : boolean = false;
    public collectionDelimiter : string | null = null;
    public customizableCollectionDelimiter : boolean = false;
    public useRecordRepetition : boolean = false;
    public fileExtension : string = "";

    public static DefaultName : string = "export";

    public defaultFilename () : string
    {
        return  `${Exporter.DefaultName}${this.fileExtension}`;
    }

    public get formatName () : string
    {
        return this.name;
    }

    public static fromDescriptor (descriptor : ExportFormatDescriptor)
        : Exporter
    {
        const exporter : Exporter = new Exporter(
            descriptor.formatName,
            descriptor.displayName,
            descriptor.description
        );
        assignOnly(
            exporter,
            descriptor,
            [
                "allowsInlining",
                "collectionDelimiter",
                "customizableCollectionDelimiter",
                "mimeType",
                "useRecordRepetition",
                "fileExtension"
            ]);

        return exporter;
    }
}



// WEBPACK FOOTER //
// ./~/angular-router-loader/src!./app/aggregation/exporter.ts